/* eslint-disable camelcase */

import React, { Component } from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18next from 'i18next';

import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import Dropdown from '~/modules/coreUI/components/basic/Dropdown';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';

const Item = styled.li`
  padding: ${props => 0.5 * props.theme.new.spacer}px ${props => 1.5 * props.theme.new.spacer}px;
  color: ${props => props.theme.new.colors.labels.normal.emphasized};
  cursor: pointer;
  &:hover{
    background-color: ${props => props.theme.new.colors.backgrounds.lightPanelHeader};
  }
`;

const SubDepartmentsList = styled.ul`
  position: fixed;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  background-color: ${props => props.theme.new.colors.named.foreGround};
  border: 1px solid ${props => props.theme.new.colors.backgrounds.lightPanelHeader};
  border-radius: ${props => 0.5 * props.theme.new.spacer}px;
  box-shadow: 1px 1.7px 5px 0 rgba(0, 0, 0, 0.05);
  list-style: none;
`;

class SubDepartmentMenu extends Component {
  state = {
    selectedSubDepartment: this.props.taxonData?.children[0]?.ref_id,
  }

  componentDidUpdate = () => {
    const indexOfSelectedId = _.findIndex(this.props.taxonData.children, o => _.isMatch(o.ref_id, this.state.selectedSubDepartment));
    if (indexOfSelectedId === -1) {
      this.setState({ selectedSubDepartment: this.props.taxonData?.children[0].ref_id });
    }
  }


  showProducts = (subdepartment, id) => {
    this.props.showProducts(subdepartment, id);
  }

  subdepartmentOptions = () => this.props.taxonData?.children.map(taxon => ({
    label: taxon.name,
    value: taxon.ref_id,
  }))

  changeSubDepartment = (value) => {
    const subdepartment = _.find(this.props.taxonData.children, subDepartment => subDepartment.ref_id === value);
    this.setState({ selectedSubDepartment: value });
    this.showProducts(subdepartment, this.props.taxonData.ref_id);
  }

  render() {
    const {
      taxonData,
      leftPosition,
      media,
      dropdownWidth,
    } = this.props;
    const { selectedSubDepartment } = this.state;

    const newCustomStyle = {
      display: 'block',
      minWidth: `${dropdownWidth}px`,
      width: 'auto',
      maxHeight: '300px',
      position: 'absolute',
      zIndex: '2',
      overflowY: 'auto',
      left: leftPosition,
      margin: '0px',
      marginTop: '5px',
      backgroundColor: 'white',
    };

    return (
      media.minDesktop ? (
        <SubDepartmentsList style={newCustomStyle}>
          {taxonData.children.map((subdepartment, index) => (
            <React.Fragment key={`menu_${subdepartment.id}`}>
              <Item onClick={() => this.showProducts(subdepartment, taxonData.ref_id)} key={subdepartment.id}>{subdepartment.name}</Item>
              {index < taxonData.children.length - 1 && <Separator separatorLength="full" spacerSize={0.3} />}
            </React.Fragment>
          ))}
        </SubDepartmentsList>
      ) : (
        <Column>
          <Spacer size={1.5} />
          <Dropdown
            options={this.subdepartmentOptions() || []}
            onChange={this.changeSubDepartment}
            placeholder={i18next.t('eCommerceShops:ShopDetails.subDepartmentPlaceholder')}
            value={selectedSubDepartment}
          />
        </Column>
      )
    );
  }
}

SubDepartmentMenu.defaultProps = {
  media: null,
  leftPosition: null,
  dropdownWidth: null,
};

SubDepartmentMenu.propTypes = {
  leftPosition: PropTypes.number,
  showProducts: PropTypes.func.isRequired,
  taxonData: PropTypes.shape({
    children: PropTypes.arrayOf(PropTypes.shape({
      ref_id: PropTypes.string,
    })),
    ref_id: PropTypes.string,
  }).isRequired,
  media: PropTypes.shape({}),
  dropdownWidth: PropTypes.number,
};

export default withMedia(SubDepartmentMenu);
